import { ReactElement, useState } from 'react'
import { useLocalization } from '../i18n/i18n'
import styled from 'styled-components'
import queryString from 'query-string'
import pointer from '../assets/pointer.svg'

const HintAnimationWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #FFFFFF;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2;
`
const HintAnimationElement = styled.div`
  position: relative;
  top: 50%;
  margin-top: -90px;
  text-align: center;
`
const HintImg = styled.img`
  display: inline-block;
  max-width: 100%;
  margin-bottom: 14px;
  animation: hintAnimation 3s infinite linear;
  animation-delay: 1s;
`
const HintText = styled.div`
  font-family: Larsseit;
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 28px;
`
const DismissButton = styled.button`
  backround: #FFFFFF;
  border: 1px solid #FCFCFC;
  padding: 4px 8px;
  margin-top: 14px;
  font-size: 14px;
  line-height: 28px;
  text-transform: uppercase;
  cursor: pointer;
  &:hover {
    background: #FCFCFC;
  }
`

const getHintDisplay = () => {
  const urlParameters = window.location.search
  const queryParameters = queryString.parse(urlParameters)

  return queryParameters.hint === 'false' ? false : true
}

const HintAnimation = (): ReactElement => {
  const [show, setShow] = useState(getHintDisplay())
  const t = useLocalization()

  const handleDismiss = () => {
    setShow(false)
  }

  return (
    <HintAnimationWrapper className={`HintAnimation ${show ? '' : 'hidden'}`}>
      <HintAnimationElement>
        <HintImg src={pointer} alt="Pointer" />
        <HintText>
          {t('hintText')}
        </HintText>
        <DismissButton onClick={handleDismiss}>
          {t('continueBtn')}
        </DismissButton>
      </HintAnimationElement>
    </HintAnimationWrapper>
  )
}

export default HintAnimation
